@if (show) {
  <app-base-edit-form
    [fields]="fields"
    [id]="salesDespatchNoteId() ?? goodsDeliveryNoteId()"
    [baseService]="shipperInterfaceHeaderService"
    [closeOnSave]="false"
    [updateModelOnSave]="true"
    (modelLoaded)="modelLoaded($event)"
    (saved)="saved()"
  >
  </app-base-edit-form>

  @if (showButtons()) {
    @if (checkMessages.length > 0) {
      <app-alert type="warning">
        <ng-container i18n>Book Shipping is unavailable until these are fixed:</ng-container>
        <ul class="mb-0 mt-1">
          @for (checkMessage of checkMessages; track $index) {
            <li>{{ checkMessage }}</li>
          }
        </ul>
      </app-alert>
    }

    @if (unsavedChanges) {
      <app-alert type="info" i18n-message message="Save your changes to re-check the shipping details"></app-alert>
    }

    <div class="d-flex justify-content-end mt-2">
      <app-base-inline-form [fields]="buttonFields" [model]="buttonModel" [marginBottom]="false"></app-base-inline-form>
    </div>
  }

  <hr />

  <app-tab-grid
    i18n-header
    header="Shipment Details"
    gridCssClass="shipper-interface-grid"
    stateKey="DespatchShipperInterfaceShipmentDetails"
    [columnDefs]="columnDefs"
    [rowData]="model?.shipperInterfaceDetails ?? []"
    [showExport]="false"
    (create)="create()"
    (edit)="editDetails($event)"
    (delete)="delete($event)"
  ></app-tab-grid>
}
